module.exports = __webpack_public_path__ + "img/NDK.e9c44f36.jpg";